module.exports = __webpack_public_path__ + "img/stvrt-mapa-centrum.76013d7c.jpg";